import { Product } from '@inter-ikea-storageone/range';
import { ProductType } from '@inter-ikea-storageone/range';
import * as R from 'ramda';

export const getProductsWithSameColor = (selectedProduct: Product, products: Product[]) => {
  const productsWithSameColor: Product[] = [];
  products.reduce((acc: Product[], curr: Product) => {
    if (!curr.appearances[0]) {
      return acc;
    }
    if (curr.appearances[0].color === selectedProduct.appearances[0].color) {
      productsWithSameColor.push(curr);
      return acc;
    } else {
      return [...acc, curr];
    }
  }, [] as Product[]);
  return productsWithSameColor;
};

export const getOneOfEachType = (types: ProductType[]) => (products: Product[]) => {
  return types.map(t => products.find(({ type }) => type === t));
};

export const getInteriorsThumbOrder = (selectedProduct: Product, products: Product[]) => {
  const productsWithSameColor = getProductsWithSameColor(selectedProduct, products);
  const oneOfEach = getOneOfEachType([
    ProductType.PAX_CLOTH_RAIL_350,
    ProductType.PAX_CLOTH_RAIL_580,
    ProductType.PAX_SHELF,
    ProductType.PAX_GLASS_DRAWER,
    ProductType.PAX_PULL_OUT_TRAY,
    ProductType.PAX_PULL_OUT_TROUSER_HANGER
  ])(productsWithSameColor);

  return [...oneOfEach, ...products.filter(p => p && !oneOfEach.includes(p))].filter(
    f => f
  ) as Product[];
};

export const getSelectedInteriorThumbOrder = (selectedProduct: Product, products: Product[]) => {
  const selected = products.filter(product => product.type === selectedProduct.type);
  const drawerCluser = [
    ProductType.PAX_DRAWER,
    ProductType.PAX_DRAWER_FRAMED,
    ProductType.PAX_DRAWER_FRAMED_GLASS,
    ProductType.PAX_DRAWER_LOCKABLE,
    ProductType.PAX_GLASS_DRAWER,
    ProductType.PAX_MESH_BASKET_ASM,
    ProductType.PAX_METAL_BASKET_ASM
  ];
  const shelfCluster = [
    ProductType.PAX_SHELF,
    ProductType.PAX_GLASS_SHELF,
    ProductType.PAX_PULL_OUT_TRAY,
    ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
    ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM
  ];

  if (drawerCluser.find(type => type === selectedProduct.type)) {
    const rest = products.filter(
      product =>
        drawerCluser.find(type => type === product.type) && product.type !== selectedProduct.type
    );
    return [...selected, ...rest] as Product[];
  }

  if (shelfCluster.find(type => type === selectedProduct.type)) {
    const rest = products.filter(
      product =>
        shelfCluster.find(type => type === product.type) && product.type !== selectedProduct.type
    );
    return [...selected, ...rest] as Product[];
  }

  return selected;
};

/**
 * Sorts corner solutions so that first product can have two 50cm wide doors
 */
export const sortCornerSolutionsBySize = (cornerSolutions: Product[], depth?: number) => {
  if (cornerSolutions.length === 0) {
    return [];
  }
  // Filter solutions with same depth on both corner and regular frame
  const solutionsInDepth =
    depth &&
    cornerSolutions.filter(solution => {
      const regularFrame = solution.parts.find(
        part => part.product?.type === ProductType.PAX_FRAME
      );
      const cornerFrame = solution.parts.find(
        part => part.product?.type === ProductType.PAX_ADD_ON_CORNER_FRAME_ASM
      );
      return (
        regularFrame?.product?.communicatedDimensions?.depth === depth &&
        cornerFrame?.product?.communicatedDimensions?.depth === depth
      );
    });
  const solutionsToSort = solutionsInDepth || cornerSolutions;
  // 850 is for 350 depth
  if (solutionsToSort[0].communicatedDimensions?.depth === 850) {
    return R.sortWith([R.ascend(R.path(['communicatedDimensions', 'width']))])(solutionsToSort);
  } else {
    return R.sortWith([R.descend(R.path(['communicatedDimensions', 'width']))])(solutionsToSort);
  }
};
